/**
 * Adds animation to scroll to anchor links
 *
 * Dependencies
 * -
 */
const ScrollToElement = {

	init: function () {
		document.querySelectorAll('.scroll-to-element').forEach(function (element) {
			element.addEventListener('click', function (event) {
				event.preventDefault();
				const link = event.currentTarget.getAttribute('href');
				const element = document.querySelector(link.substring(link.indexOf('#')));
				element && element.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			});
		});
	},

};

export default ScrollToElement;
